// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectRoofCoveringQueryResult, selectRoofCoveringsPageLoading, selectRoofCoveringsShowInitWaitingMessage} from '../_selectors/roof-covering.selectors';

export class RoofCoveringsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRoofCoveringsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRoofCoveringsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRoofCoveringQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
